import axios from "axios";

export const countriesData = () => {
  return axios
    .get("/countries")
    .then((response) => {
    //   console.log(response.data);
      return response;
    });
};